module.exports = __webpack_public_path__ + "img/register.e0809156.svg";